<!-- §6 search bar: 48 high, pill, 20 icon, 12 gap. Solar magnifer-linear. -->
<label class="cs-search">
  <svg class="cs-search-icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5">
      <circle cx="11.5" cy="11.5" r="9.5" />
      <path d="M18.2173 18.2178L21.9999 22.0004" />
    </g>
  </svg>
  <input #searchInput class="cs-search-input" type="text" [value]="query" (input)="onQuery(searchInput.value)"
    (keydown.enter)="onEnter($event)" placeholder="Search or add your own" maxlength="50"
    aria-label="Search or add your own" enterkeyhint="done" autocomplete="off" />
</label>

<ng-container *ngIf="results.addLabel">
  <div class="cs-group cs-group--add" role="list">
    <button type="button" class="cs-row cs-row--add" role="listitem" (click)="add()">
      <!-- Solar add-circle-linear -->
      <svg class="cs-row-icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5">
          <circle cx="12" cy="12" r="10" />
          <path d="M15 12L12 12M12 12L9 12M12 12L12 9M12 12L12 15" />
        </g>
      </svg>
      <span class="cs-row-label">Add “{{ results.addLabel }}”</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="results.yours.length">
  <p class="cs-eyebrow">Yours</p>
  <div class="cs-chips" role="list">
    <button *ngFor="let own of results.yours; trackBy: trackByLabel" type="button" class="cs-chip" role="listitem"
      [class.is-selected]="isSelected(own)" [attr.aria-pressed]="isSelected(own)" (click)="pick(own, 'yours')">
      {{ own }}
    </button>
  </div>
</ng-container>

<ng-container *ngIf="results.popular.length">
  <p class="cs-eyebrow">Popular</p>
  <div class="cs-group" role="list">
    <button *ngFor="let c of results.popular; trackBy: trackByLabel" type="button" class="cs-row" role="listitem"
      [attr.aria-pressed]="isSelected(c.label)" (click)="pick(c.label, 'popular')">
      <span class="cs-row-label">{{ c.label }}</span>
      <!-- Solar check-linear -->
      <svg *ngIf="isSelected(c.label)" class="cs-row-check" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 13L9 17L19 7" />
      </svg>
    </button>
  </div>
</ng-container>

